import { createSecretKey } from "@core/foundation/token";
import type { z } from "@core/zod";

import { KEY_PREFIX } from "./key-prefix.ts";

export const {
  generateKey: generateOAuthRefreshKey,
  keySchema: OAuthRefreshKeySchema,
  verifyKey: verifyOAuthRefreshKey,
} = createSecretKey({ keyPrefix: KEY_PREFIX.OAUTH_REFRESH });

export type OAuthRefreshKey = z.infer<typeof OAuthRefreshKeySchema>;
